import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FeedbackService extends RestService {

	constructor(protected http: HttpClient, ) {
		super(http);
		this.url = environment.api + '/feedback';
	}
}